import { Avatar, HStack, Text, VStack } from '@chakra-ui/react'

export function UserIdentity({ user = {}, fallbackName = '—' }) {
  const username = user.username || ''
  const fullName = [user.first_name, user.last_name].filter(Boolean).join(' ')
  const displayName = fullName || fallbackName || username || '—'
  const initials = (user.first_name?.[0] || username[0] || displayName[0] || '?').toUpperCase()

  return (
    <HStack gap={3} minW={0}>
      <Avatar.Root size="sm" bg="#0052CC" color="white" name={displayName}>
        {user.avatar ? <Avatar.Image src={user.avatar} alt={displayName} /> : null}
        <Avatar.Fallback fontSize="12px" fontWeight="600">{initials}</Avatar.Fallback>
      </Avatar.Root>
      <VStack align="start" gap={0} minW={0}>
        <Text fontSize="14px" fontWeight="500" color="#172B4D" truncate>
          {displayName}
        </Text>
        {username && username !== displayName && (
          <Text fontSize="12px" color="#5E6C84" truncate>@{username}</Text>
        )}
      </VStack>
    </HStack>
  )
}

export default UserIdentity